import { gql } from '@apollo/client'

export const GENERATE_PRESIGNED_URL = gql`
  query generatePresignedUrl($path: String!) {
    presignedUrl: generate_presigned_url(S3Path: $path)
  }
`

export const GENERATE_PUT_OBJECT_PRESIGNED_URL = gql`
  mutation generatePutObjectPresignedUrl(
    $input: GeneratePutObjectPresignedUrlInput!
  ) {
    generate_put_object_presigned_url(input: $input) {
      S3Key
      SignedUrl
    }
  }
`
